import LibraryElementEnum from 'client/enums/LibraryElementEnum'
import { RecaptchaIconNew } from 'common/components/entities/Recaptcha/ui/recaptcha-icon-new'
import toolBoxTypes from 'common/constants/toolBoxTypes'

export const libraryItems = {
  [LibraryElementEnum.LibrarySection]: {
    className: 'base-element-icon section-element-icon',
    title: 'toolbox.entities.section',
  },
  [LibraryElementEnum.LibraryRow]: {
    className: 'column column-12-new',
    title: 'toolbox.entities.column_12',
  },
  [LibraryElementEnum.LibraryColumn6]: {
    className: 'column column-6-6-new',
    title: 'toolbox.entities.column_6_6',
  },
  [LibraryElementEnum.LibraryColumn4]: {
    className: 'fa-light fa-columns-3',
    title: 'toolbox.entities.column_4_4_4',
  },
  [LibraryElementEnum.LibraryColumn3]: {
    className: 'column column-3-3-3-3-new',
    title: 'toolbox.entities.column_3_3_3_3',
  },
  [LibraryElementEnum.LibraryContentBox]: {
    className: 'fa-light fa-window-maximize',
    title: 'toolbox.entities.content_box',
  },
  [LibraryElementEnum.LibraryHeadline]: {
    className: 'fa-light fa-heading',
    // title: 'toolbox.entities.text_headline',
    title: 'toolbox.entities.headline',
  },
  [LibraryElementEnum.LibraryBulletList]: {
    className: 'fa-light fa-list-ul',
    title: 'toolbox.entities.bullet_list',
  },
  [LibraryElementEnum.LibraryCalendar]: {
    className: 'fa-light fa-calendar',
    title: 'toolbox.entities.calendar',
  },
  [LibraryElementEnum.LibraryPaidCalendar]: {
    className: 'fa-light fa-calendar-days',
    title: 'toolbox.entities.paid_calendar',
  },
  [LibraryElementEnum.LibraryVideo]: {
    className: 'base-element-icon video-icon',
    title: 'toolbox.entities.video',
  },
  [LibraryElementEnum.LibraryImage]: {
    className: 'base-element-icon image-icon',
    title: 'toolbox.entities.image',
  },
  [LibraryElementEnum.LibraryAudio]: {
    className: 'fa-light fa-volume-low',
    title: 'toolbox.entities.audio',
  },
  [toolBoxTypes.TOOLBOX_BUTTON]: {
    className: 'base-element-icon button-element-icon',
    title: 'toolbox.entities.button',
  },
  [LibraryElementEnum.LibraryButton]: {
    className: 'base-element-icon button-element-icon',
    title: 'toolbox.entities.button',
  },
  [LibraryElementEnum.LibraryWebsiteButton]: {
    className: 'base-element-icon button-element-icon',
    title: 'toolbox.entities.button',
  },
  [LibraryElementEnum.LibraryLoginButton]: {
    className: 'base-element-icon login-element-icon',
    title: 'toolbox.entities.login_button',
  },
  [LibraryElementEnum.LibraryRegistrationButton]: {
    className: 'base-element-icon registration-element-icon',
    title: 'toolbox.entities.registration_button',
  },
  [LibraryElementEnum.LibraryOpenUrlButton]: {
    className: 'base-element-icon button-element-icon',
    title: 'toolbox.entities.button',
  },
  [toolBoxTypes.TOOLBOX_BLOG_BUTTON]: {
    className: 'base-element-icon button-element-icon',
    title: 'toolbox.entities.button',
  },
  [toolBoxTypes.TOOLBOX_OPEN_URL_BUTTON]: {
    className: 'base-element-icon button-element-icon',
    title: 'toolbox.entities.button',
  },
  [toolBoxTypes.TOOLBOX_PAYMENT_BUTTON]: {
    className: 'base-element-icon payment-button-icon',
    title: 'toolbox.entities.payment_button',
  },
  [LibraryElementEnum.LibraryPaymentButton]: {
    className: 'base-element-icon payment-button-icon',
    title: 'toolbox.entities.payment_button',
  },
  [LibraryElementEnum.LibraryUpsellAgreeButton]: {
    className: 'far fa-thumbs-up',
    title: 'toolbox.entities.payment_button_agree',
  },
  [LibraryElementEnum.LibraryUpsellDisagreeButton]: {
    className: 'far fa-thumbs-down',
    title: 'toolbox.entities.payment_button_disagree',
  },
  [LibraryElementEnum.LibraryField]: {
    className: 'base-element-icon form-input-icon',
    title: 'toolbox.entities.form_input',
  },
  [LibraryElementEnum.LibraryForm]: {
    className: 'base-element-icon form-icon',
    title: 'toolbox.entities.form',
  },
  [toolBoxTypes.TOOLBOX_START_TIMER]: {
    className: 'far fa-clock',
    title: 'toolbox.entities.start_timer',
  },
  [LibraryElementEnum.LibraryCountdown]: {
    className: 'base-element-icon countdown-icon',
    title: 'toolbox.entities.countdown',
  },
  [LibraryElementEnum.LibraryWebinarRegistrationDate]: {
    className: 'fas fa-calendar-alt',
    title: 'toolbox.entities.webinar_registration_date',
  },
  [LibraryElementEnum.LibraryOrderSummary]: {
    className: 'fas fa-shopping-cart',
    title: 'toolbox.entities.order_summary',
  },
  [LibraryElementEnum.LibraryWebinarSessionDateTime]: {
    className: 'far fa-clock',
    title: 'toolbox.entities.webinar_session_date_time',
  },
  [LibraryElementEnum.LibraryWebinarSessionLink]: {
    className: 'fas fa-link',
    title: 'toolbox.entities.webinar_session_link',
  },
  [LibraryElementEnum.LibraryCustomerType]: {
    className: 'base-element-icon customer-type-icon',
    title: 'toolbox.entities.customer_type',
  },
  [LibraryElementEnum.LibraryOfferPrice]: {
    className: 'fa-light fa-circle-dollar',
    title: 'toolbox.entities.offer_price',
  },
  [LibraryElementEnum.LibraryRawHTML]: {
    className: 'base-element-icon raw-html-icon',
    title: 'toolbox.entities.raw_html',
  },
  [LibraryElementEnum.LibraryCheckbox]: {
    className: 'fa-light fa-square-check',
    title: 'toolbox.entities.checkbox',
  },
  [LibraryElementEnum.LibraryAgreement]: {
    className: 'base-element-icon agreement-icon',
    title: 'toolbox.entities.agreement',
  },
  [toolBoxTypes.TOOLBOX_CUSTOM_LOGIN]: {
    className: 'fas fa-sign-in-alt',
    title: 'toolbox.entities.member_access',
  },
  [LibraryElementEnum.LibraryCustomLogin]: {
    className: 'fas fa-sign-in-alt',
    title: 'toolbox.entities.member_access',
  },
  [toolBoxTypes.TOOLBOX_SALES_PHYSICAL_PRODUCT]: {
    className: 'fa-light fa-box-archive',
    title: 'toolbox.entities.physical_product',
  },
  [LibraryElementEnum.LibraryProduct]: {
    className: 'fa-light fa-box-archive',
    title: 'toolbox.entities.physical_product',
  },
  [toolBoxTypes.TOOLBOX_PAYMENT_PHYSICAL_PRODUCT]: {
    className: 'fa-light fa-box-archive',
    title: 'toolbox.entities.physical_product',
  },
  [LibraryElementEnum.LibrarySalesRedirectionButton]: {
    className: 'fas fa-link',
    title: 'toolbox.entities.sales_redirection_button',
  },
  [LibraryElementEnum.LibraryCoupon]: {
    className: 'fa-light fa-badge-percent',
    title: 'toolbox.entities.coupon',
  },
  [LibraryElementEnum.LibraryWebinarCallToAction]: {
    className: 'far fa-hand-point-up',
    title: 'toolbox.entities.webinar_session_call_to_action',
  },
  [LibraryElementEnum.LibraryWebinarSessionVideo]: {
    className: 'fas fa-video',
    title: 'toolbox.entities.webinar_session_video',
  },
  [LibraryElementEnum.LibraryPaymentMethod]: {
    className: 'base-element-icon payment-method-icon',
    title: 'toolbox.entities.payment_method',
  },
  [LibraryElementEnum.LibraryBlogPostBody]: {
    className: 'base-element-icon blog-post-body-icon',
    // title: 'toolbox.entities.blog_post_body',
    title: 'toolbox.entities.post_content',
  },
  [LibraryElementEnum.LibraryBlogPostTitle]: {
    className: 'fa-light fa-heading',
    // title: 'toolbox.entities.blog_post_title',
    title: 'toolbox.entities.post_title',
  },

  [LibraryElementEnum.LibraryBlogPostDate]: {
    className: 'fa-light fa-calendar',
    // title: 'toolbox.entities.blog_post_date',
    title: 'toolbox.entities.post_date',
  },
  [LibraryElementEnum.LibraryBlogPostCategories]: {
    className: 'fa-light fa-filter',
    // title: 'toolbox.entities.blog_post_categories',
    title: 'toolbox.entities.post_categories',
  },
  [LibraryElementEnum.LibraryBlogPostListing]: {
    className: 'column-new posts-library-icon-new',
    // title: 'toolbox.entities.blog_post_listing',
    title: 'toolbox.entities.post_listing',
  },
  [LibraryElementEnum.LibraryBlogLatestPosts]: {
    // className: 'latest-posts-library-icon',
    className: 'base-element-icon latest-posts-icon',
    // title: 'toolbox.entities.latest_blog_posts',
    title: 'toolbox.entities.latest_posts',
  },
  [LibraryElementEnum.LibraryLatestBlogPostsCarousel]: {
    // className: 'far fa-images',
    className: 'base-element-icon latest-posts-carousel-icon',
    // title: 'toolbox.entities.latest_blog_posts_carousel',
    title: 'toolbox.entities.latest_posts_carousel',
  },
  [LibraryElementEnum.LibraryHorizontalLine]: {
    className: 'fa-light fa-horizontal-rule',
    title: 'toolbox.entities.horizontal_line',
  },
  [LibraryElementEnum.LibraryBlogContentPlaceholder]: {
    className: 'far fa-newspaper',
    title: 'toolbox.entities.blog_content',
  },
  [LibraryElementEnum.LibraryMenu]: {
    className: 'fa-light fa-bars',
    title: 'toolbox.entities.menu',
  },
  [LibraryElementEnum.LibraryLanguageSwitcher]: {
    className: 'fas fa-globe',
    title: 'toolbox.entities.language_switcher',
  },
  [LibraryElementEnum.LibraryTwoStepPaymentForm]: {
    className: 'fa-light fa-cart-shopping',
    title: 'toolbox.entities.two_step_payment_form',
  },
  [LibraryElementEnum.LibraryTwitterTweetButton]: {
    className: 'base-element-icon x-icon',
    title: 'toolbox.entities.twitter_tweet_button',
  },
  [LibraryElementEnum.LibraryCarousel]: {
    className: 'base-element-icon carousel-icon',
    title: 'toolbox.entities.carousel',
  },
  [LibraryElementEnum.LibraryFaq]: {
    className: 'fa-light fa-circle-question',
    title: 'toolbox.entities.faq',
  },
  [LibraryElementEnum.LibraryText]: {
    className: 'base-element-icon text-element-icon',
    title: 'toolbox.entities.text',
  },
  [LibraryElementEnum.LibraryBlogPostImage]: {
    className: 'base-element-icon image-icon',
    // title: 'toolbox.entities.blog_post_image',
    title: 'toolbox.entities.post_image',
  },
  [LibraryElementEnum.LibraryContentTable]: {
    className: 'fa-light fa-bars',
    title: 'toolbox.entities.content_table',
  },
  [LibraryElementEnum.LibraryContactUs]: {
    className: 'fal fa-envelope-open-text',
    title: 'toolbox.entities.contact_us',
  },
  [LibraryElementEnum.LibraryBreadcrumbs]: {
    className: 'base-element-icon breadcrumbs-icon',
    title: 'toolbox.entities.breadcrumbs',
  },
  [LibraryElementEnum.LibrarySurvey]: {
    className: 'base-element-icon survey-icon',
    title: 'toolbox.entities.survey',
  },
  [LibraryElementEnum.LibraryBlogCategoryTitle]: {
    className: 'fa-light fa-heading',
    title: 'toolbox.entities.blog_category_title',
  },
  [LibraryElementEnum.LibraryBlogCategoryDescription]: {
    className: 'fa-light fa-paragraph',
    title: 'toolbox.entities.blog_category_description',
  },
  [LibraryElementEnum.LibraryOptInRecaptcha]: {
    title: 'toolbox.entities.recaptcha',
    iconRenderer: RecaptchaIconNew,
  },
  [LibraryElementEnum.LibraryShippingFees]: {
    className: 'base-element-icon shipping-fees-icon',
    title: 'toolbox.entities.shipping_fees',
  },
  [LibraryElementEnum.LibraryOrderBump]: {
    className: 'base-element-icon order-bump-icon',
    title: 'toolbox.entities.order_bump',
  },
  [LibraryElementEnum.LibraryPriceElement]: {
    className: 'far fa-table',
    title: 'toolbox.entities.price_element',
  },
  [LibraryElementEnum.LibrarySearchResults]: {
    className: 'far fa-table-list',
    title: 'toolbox.entities.search_results',
  },
  [LibraryElementEnum.LibrarySearch]: {
    className: 'far fa-magnifying-glass',
    title: 'toolbox.entities.search',
  },
  [LibraryElementEnum.LibraryWebsiteLogo]: {
    className: 'base-element-icon logo-icon',
    title: 'toolbox.entities.logo',
  },
  [LibraryElementEnum.LibraryWebsiteLanguageSwitcher]: {
    className: 'base-element-icon language-switcher-icon',
    title: 'toolbox.entities.language_switcher',
  },
}

export const libraryGroups = {
  sio: 'sio',
  text: 'text',
  media: 'media',
  layout: 'layout',
  payment: 'payment',
  form: 'form',
  webinar: 'webinar',
  social: 'social',
  blog: 'blog',
  other: 'other',
}

export const libraryGroupsTitles = {
  [libraryGroups.sio]: 'toolbox.groups.systeme_io',
  [libraryGroups.text]: 'toolbox.groups.text',
  [libraryGroups.media]: 'toolbox.groups.media',
  [libraryGroups.layout]: 'toolbox.groups.layout',
  [libraryGroups.payment]: 'toolbox.groups.payment',
  [libraryGroups.form]: 'toolbox.groups.form',
  [libraryGroups.webinar]: 'toolbox.groups.webinar',
  [libraryGroups.social]: 'toolbox.groups.social',
  [libraryGroups.other]: 'toolbox.groups.other',
  [libraryGroups.blog]: 'toolbox.groups.blog',
}
